import api from './api';

export interface CalendarEvent {
  id: string;
  user_id: string;
  title: string;
  description: string | null;
  start_at: string;
  end_at: string;
  all_day: boolean;
  location: string | null;
  meet_url: string | null;
  source_type: 'manual' | 'chat_meeting';
  source_id: string | null;
  response: 'ACCEPTED' | 'TENTATIVE' | 'DECLINED' | 'NEEDS_ACTION';
  created_at: string;
  updated_at: string;
}

export async function listEvents(from: Date, to: Date): Promise<CalendarEvent[]> {
  const r = await api.get<{ items: CalendarEvent[] }>('/api/calendar/events', {
    params: { from: from.toISOString(), to: to.toISOString() },
  });
  return r.data.items;
}

export async function createEvent(input: {
  title: string; description?: string; start_at: string; end_at: string;
  all_day?: boolean; location?: string; meet_url?: string;
}): Promise<CalendarEvent> {
  const r = await api.post<CalendarEvent>('/api/calendar/events', input);
  return r.data;
}

export async function updateEvent(id: string, input: Partial<{
  title: string; description: string; start_at: string; end_at: string;
  all_day: boolean; location: string;
}>): Promise<CalendarEvent> {
  const r = await api.patch<CalendarEvent>(`/api/calendar/events/${id}`, input);
  return r.data;
}

export async function deleteEvent(id: string): Promise<void> {
  await api.delete(`/api/calendar/events/${id}`);
}

export async function respondEvent(id: string, response: CalendarEvent['response']): Promise<CalendarEvent> {
  const r = await api.post<CalendarEvent>(`/api/calendar/events/${id}/respond`, { response });
  return r.data;
}
